export const eventTrack = (category, action, label) => {
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({
		event: 'event',
		eventCategory: category,
		eventAction: action,
		eventLabel: label
	})
}
